import * as yup from 'yup';

export const LoginSchema = yup.object({
	email: yup.string().email().required('Please enter your email'),
	password: yup.string().required('Please enter your password'),
});
export const ForgotPasswordSchema = yup.object({
	email: yup.string().email().required('Please enter your email'),
});
export const ResetPasswordSchema = yup.object({
	password: yup.string()
		.min(8, 'Password must be at least 8 characters long')
		.matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
		.matches(/[0-9]/, 'Password must contain at least one number')
		.required('Password is required'),
	passwordConfirmation: yup.string()
		.oneOf([yup.ref('password'), null], 'Passwords must match')
		.required('Confirm Password is required'),
});

export const investorAppInfoSchema = yup.object({
	investorTypeId: yup.number().required('This is a mandatory field').nullable(),
	contactNumber: yup.object().required('This is a mandatory field').nullable(),
	firstName: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	lastName: yup.string().required('This is a mandatory field').nullable(),
	estimatedAnnualInvestmentId: yup
		.string()
		.required('This is a mandatory field')
		.nullable(),
	birthDate: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	passportExpiry: yup
		.string()
		.required('This is a mandatory field')
		.nullable().test('is-future-date', 'The passport is expired', function (value) {
			if (!value) return false;
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			const expiryDate = new Date(value);
			return expiryDate >= today;
		}),
	nationalityId: yup.number().required('This is a mandatory field').nullable(),
	companyName: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	jobTitle: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	placeOfBirth: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	employmentStatusId: yup
		.number()
		.nullable(),
	bankName: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	bankAccountName: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	routingNumber: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	accountNumber: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	swiftCode: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	bankCountryId: yup.number().nullable(),
	annualIncomeId: yup.number().required('This is a mandatory field').nullable(),
	address: yup
		.object({
			addressLine: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			additionalAddressLine: yup
				.string()
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			city: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			postalCode: yup
				.string()
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			countryId: yup.number().required('This is a mandatory field').nullable(),
		})
		.nullable(),
	industry: yup
		.object({
			valueId: yup.number().nullable(),
		})
		.nullable(),
	incomeSource: yup
		.object({
			valueId: yup.number().nullable(),
			valueSpecified: yup
				.string()
				.when('value', {
					is: 'Other',
					then: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
					otherwise: yup
						.string()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
				.nullable(),
		})
		.nullable(),
	howDidHearAboutUs: yup
		.object({
			valueId: yup.number().nullable(),
			valueSpecified: yup
				.string()
				.when('value', {
					is: 'Other',
					then: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
					otherwise: yup
						.string()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
				.nullable(),
		})
		.nullable(),
	publicFunction: yup
		.object({
			valueId: yup.number().nullable(),
			valueSpecified: yup
				.string()
				.when('value', {
					is: 'Other',
					then: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
					otherwise: yup
						.string()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
				.nullable(),
		})
		.nullable(),
});

export const InvestorBaseInfoSchema = yup.object({
	nationalId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	amlReviewDate: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const InvestorCorporateSchema = yup.object({
	businessName: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	turnOver: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessLandLine: yup
		.object()
		.required('This is a mandatory field')
		.nullable(),
});

export const AddTransactionSchema = yup.object({
	isDeposit: yup.boolean().required('This is a mandatory field').nullable(),
	amount: yup
		.number()
		.required('This is a mandatory field')
		.min(1, 'Amount should be greater than 1')
		.max(10000000, 'Amount should be less than 10000000')
		.nullable(),
});

export const OverllRiskSchema = yup.object({
	overallRiskAssesment: yup
		.string()
		.required('This is a mandatory field')
		.nullable(),
});

export const BorrowerPersonalSchema = yup.object({
	nationalId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	firstName: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	lastName: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	// countryOfRegistrationId: yup
	// 	.number()
	// 	.required('This is a mandatory field')
	// 	.nullable(),
	birthDate: yup
		.string()
		.required('This is a mandatory field')
		.test('birthDate', 'Borrower must be at least 18 years old', function (value) {
			if (!value) return true;
			const dob = new Date(value);
			const eighteenYearsAgo = new Date();
			eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
			return dob.getTime() <= eighteenYearsAgo.getTime();
		})
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	passportExpiry: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	// yearsOfOperationId: yup
	// 	.number()
	// 	.required('This is a mandatory field')
	// 	.nullable(),
	propertyOwnershipId: yup
		.number()
		.required('This is a mandatory field')
		.nullable(),
	nationalityId: yup
		.number()
		.required('This is a mandatory field')
		.nullable(),
	maritalStatusId: yup
		.number()
		.required('This is a mandatory field')
		.nullable(),
	numberOfChildrenId: yup
		.number()
		.required('This is a mandatory field')
		.nullable(),
	otherIssues: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	ongoingPoliceInvestigation: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	address: yup
		.object({
			addressLine: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			countryId: yup.number().required('This is a mandatory field').nullable(),
		})
		.nullable(),
	howDidHearAboutUs: yup
		.object({
			valueId: yup.number().nullable(),
			valueSpecified: yup
				.string()
				.when('value', {
					is: 'Other',
					then: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
					otherwise: yup
						.string()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
				.nullable(),
		})
		.nullable(),
	publicFunction: yup
		.object({
			valueId: yup.number().nullable(),
			valueSpecified: yup
				.string()
				.when('value', {
					is: 'Other',
					then: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
					otherwise: yup
						.string()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
				.nullable(),
		})
		.nullable(),
});

export const BorrowerBusinessSchema = yup.object({
	webSite: yup
		.string()
		.matches(
			/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
			'Enter correct url!'
		)
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessLandLine: yup
		.object()
		.required('This is a mandatory field')
		.nullable(),
	turnover: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	profit: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	needFundsFor: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	totalOutstandingDebt: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	headcountId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	debtInLastYear: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	numberOfBanksId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	registrationPlaceId: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	companyTypeId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	address: yup
		.object({
			addressLine: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			countryId: yup.number().required('This is a mandatory field').nullable(),
		})
		.nullable(),
});

export const BorrowerTemplateSchema = yup.object({
	businessIndustryEnglish: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessIndustryArabic: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessTypeEnglish: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessTypeArabic: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessRegion: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	// businessPurpose: yup
	// 	.string()
	// 	.required('This is a mandatory field')
	// 	.nullable()
	// 	.trim()
	// 	.transform((v, o) => (o === '' ? null : v)),
	businessYears: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	businessToGrowId: yup.number().nullable(),
});

export const LoanParametersSchema = yup.object({
	paymentFrequency: yup
		.number()
		.required('This is a mandatory field')
		.nullable(),
	investorIRR: yup.number().required('This is a mandatory field').nullable(),
	originationFee: yup
		.number()
		.required('This is a mandatory field')
		.min(0, 'Amount should be greater than 0')
		.max(99, 'Amount should be less than 99')
		.nullable(),
	profit: yup
		.number()
		.required('This is a mandatory field')
		.min(0, 'Amount should be greater than 0')
		.max(100, 'Amount should be less than 100')
		.nullable(),
	investorProfit: yup
		.number()
		.required('This is a mandatory field')
		.min(0, 'Amount should be greater than 0')
		.max(100, 'Amount should be less than 100')
		.nullable(),
	rating: yup.string().required('This is a mandatory field').nullable(),
	tenure: yup
		.number()
		.required('This is a mandatory field')
		.min(0, 'Amount should be greater than 0')
		.max(60, 'Amount should be less than 60')
		.nullable(),
	isRestructured: yup
		.boolean()
		.required('This is a mandatory field')
		.nullable(),
	collateralId: yup.number().required('This is a mandatory field').nullable(),
});

export const LoanPaymentScheduleSchema = yup.object({
	payments: yup.array().of(
		yup.object({
			dueDate: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			principal: yup.number().required('This is a mandatory field').nullable(),
			profit: yup
				.number()
				.required('This is a mandatory field')
				.when('investorProfit', (investorProfit, schema) => {
					return schema.test({
						test: (profit) => profit >= investorProfit,
						message:
							'Profit Flat should be greater than or equal to Investor Profit',
					});
				})
				.nullable(),
			investorProfit: yup
				.number()
				.required('This is a mandatory field')
				.nullable(),
		})
	),
});

export const GeneratePaymentScheduleSchema = yup.object().shape({
	paymentStartDate: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const AddTransactionScheduleSchema = yup.object().shape({
	debitAccountTypeId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	debitAccountId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	creditAccountTypeId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	creditAccountId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	amount: yup.number().required('This is a mandatory field'),
	comment: yup
		.string()
		.trim()
		.transform((v, o) => (o === '' ? null : v))
		.required('This is a mandatory field'),
});

export const MembersSchema = yup.object().shape({
	position: yup
		.array()
		.of(
			yup.object({
				fullName: yup.string().required('This is a mandatory field').nullable(),
			})
		)
		.when('type', {
			is: (type) => /^(20)$/.test(type),
			then: yup.array().of(
				yup.object({
					title: yup
						.string()
						.required('This is a mandatory field')
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
			),
			otherwise: yup.array().of(
				yup.object({
					title: yup
						.string()
						.notRequired()
						.nullable()
						.trim()
						.transform((v, o) => (o === '' ? null : v)),
				})
			),
		}),
});

export const PushNotificationSchema = yup.object().shape({
	templateName: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const PushNotificationSendSchema = yup.object().shape({
	pushNotificationReceivers: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const StaticPageSchema = yup.object().shape({
	slug: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup.string().required('This is a mandatory field').nullable(),
		})
	),
});

export const BlogCategorySchema = yup.object().shape({
	slag: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
		})
	),
});

export const MetaTagSchema = yup.object().shape({
	tags: yup.array(
		yup.object().shape({
			page: yup.array(
				yup.object().shape({
					pageName: yup
						.string()
						.required('This is a mandatory field')
						// .matches(
						// 	'^[a-z](-?[a-z])*$',
						// 	'Invalid page name'
						// )
						.nullable(),
					title: yup
						.string()
						.max(75, 'Title should be less than 75 characters')
						.required('This is a mandatory field')
						.nullable(),
					description: yup
						.string()
						.required('This is a mandatory field')
						.max(250, 'Meta description should be less than 250 characters')
						.nullable(),
					imageUrl: yup
						.string()
						.matches('^https?://', 'Invalid image url')
						.nullable(),
				})
			),
		})
	),
});

export const BlogArticleSchema = yup.object().shape({
	categoryId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	slag: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup.string().required('This is a mandatory field').nullable(),
			altTagText: yup.string().required('This is a mandatory field').nullable(),
			metaTitle: yup
				.string()
				.max(75, 'Meta Title should be less than 75 characters')
				.nullable(),
			metaDescription: yup
				.string()
				.max(170, 'Meta description should be less than 170 characters')
				.nullable(),
		})
	),
});

export const ComparisonSchema = yup.object().shape({
	slug: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup.string().required('This is a mandatory field').nullable(),
			subTitle: yup.string().required('This is a mandatory field').nullable(),
			overview: yup.string().required('This is a mandatory field').nullable(),
			metaTitle: yup
				.string()
				.max(75, 'Meta Title should be less than 75 characters')
				.nullable(),
			metaDescription: yup
				.string()
				.max(170, 'Meta description should be less than 170 characters')
				.nullable(),
		})
	),
});

export const AnnouncementBarSchema = yup.object().shape({
	languages: yup.array().of(
		yup.object({
			title: yup.string().required('This is a mandatory field').nullable(),
			text: yup.string().required('This is a mandatory field').nullable(),
			buttonName: yup.string().required('This is a mandatory field').nullable(),
			linkTranslation: yup
				.string()
				.required('This is a mandatory field')
				.nullable(),
		})
	),
});

export const FAQCategorySchema = yup.object().shape({
	slag: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup
				.string()
				.required('This is a mandatory field')
				.nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
		})
	),
});

export const FAQSchema = yup.object().shape({
	categoryId: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			question: yup.string().required('This is a mandatory field').nullable(),
		})
	),
});

export const BucketSchema = yup.object().shape({
	// name: yup.string().required('This is a mandatory field').nullable(),
	maxExposure: yup
		.number()
		.required('This is a mandatory field')
		.min(0, 'This field should be greater than 0')
		.max(100, 'This field should be less than 100')
		.nullable(),
	type: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	roiPercent: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	languages: yup.array().of(
		yup.object({
			title: yup.string().required('This is a mandatory field').nullable(),
		})
	),
});

export const InvestAmountSchema = yup.object().shape({
	// name: yup.string().required('This is a mandatory field').nullable(),
	amount: yup
		.number()
		.required('This is a mandatory field')
		.min(10, 'Amount should be greater than 10')
		.test('', 'Amount should be multiple of 10s', (value) => {
			if (value % 10 > 0) {
				return false;
			}
			return true;
		})
		.nullable(),
});
const arraySchema = yup.array()
	.of(yup.lazy((_, options) => objectSchema(options.index)));

const objectSchema = (index) => yup.object().shape({
	periodEnding: yup.string()
		.when([], {
			is: () => index < 2,
			then: yup.string().required('This is a mandatory field').nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v)),
			otherwise: yup.string().nullable()
				.trim()
				.transform((v, o) => (o === '' ? null : v))
		}),
	// Add other properties if needed
});

export const RatioSchema = yup.object().shape({
	ratios: arraySchema
});

export const LoanCommentSchema = yup.object().shape({
	comment: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const LoanTemplateSchema = yup.object().shape({
	expirationDate: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const GoogleIndexingRequestSchema = yup.object().shape({
	tags: yup.array(
		yup.object().shape({
			page: yup.array(
				yup.object().shape({
					url: yup.string().required('This is a mandatory field').nullable(),
					type: yup.number().required('This is a mandatory field').nullable(),
				})
			),
		})
	),
});

export const FinancialStatementSchema = yup.object({
	assets: yup.object({
		cashOnHandAtBank: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		accountReceivables: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		inventory: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		other: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		ppAndE: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		totalAssets: yup.array(
			yup.object({
				value: yup.number().min(1).required('required').nullable(),
			})
		),
	}),
	liability: yup.object({
		accountPayable: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		borrowings: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		other: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		totalLiabilities: yup.array(
			yup.object({
				value: yup.number().min(1).required('required').nullable(),
			})
		),
		paidInCapital: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		retainedEarnings: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		currentYearNetProfit: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		ownersEquityAccount: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		totalOwnersEquity: yup.array(
			yup.object({
				value: yup.number().min(1).required('required').nullable(),
			})
		),
		totalLiabilityAndEquity: yup.array(
			yup.object({
				value: yup.number().min(1).required('required').nullable(),
			})
		),
	}),
	incomeStatements: yup.object({
		totalRevenue: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		totalExpenses: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
		netProfit: yup.array(
			yup.object({
				value: yup.mixed().required('required').nullable(),
			})
		),
	}),
});

export const AdminUserSchema = yup.object({
	email: yup.string().email().required('Please enter your email').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	contactNumber: yup.object().required('This is a mandatory field').nullable(),
	password: yup.string()
		.min(8, 'Password must be at least 8 characters long')
		.matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
		.matches(/[0-9]/, 'Password must contain at least one number')
		.required('Password is required').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	passwordConfirmation: yup.string()
		.oneOf([yup.ref('password'), null], 'Passwords must match')
		.required('Confirm Password is required').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	profile: yup.object({
		firstName: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		lastName: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
	}
	),
	role: yup
		.string()
		.required('This is a mandatory field')
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const CRBusinessSchema = yup.object().shape({
	basicInfo: yup.object().shape({
		isLoanGuaranteed: yup
			.mixed()
			.required('This is a mandatory field')
			.nullable(),
		lengthOfBusiness: yup
			.mixed()
			.required('This is a mandatory field')
			.nullable(),
		creditBureauScoreCompany: yup
			.mixed()
			.required('This is a mandatory field')
			.nullable()
	})
});

export const CRSignatorySchema = yup.object().shape({
	signatoryDetails: yup.array().of(
		yup.object().shape({
			isPropertyOwner: yup.mixed().required('This is a mandatory field'),
			hasKidsInUAE: yup.mixed().required('This is a mandatory field'),
			kidsInUAESchools: yup.mixed().required('This is a mandatory field'),
			ageBetween25And65: yup.mixed().required('This is a mandatory field'),
			signatoryEngagementInBusiness: yup.mixed().required('This is a mandatory field'),
			creditBureauScoreIndividual: yup.mixed().required('This is a mandatory field')
		})
	),
});

export const CRBCOtherInfoSchema = yup.object().shape({
	chequeReturns: yup.object().shape({
		hasAuditedFinancialStatements: yup.mixed().required('This is a mandatory field'),
	}),
	bankingDetailsOfProposedCompany: yup.object().shape({
		averageBalance12Months: yup.mixed().required('This is a mandatory field'),
	}),
	borrowingsLoans: yup.object().shape({
		numberOfLendersExceptFS: yup.mixed().required('This is a mandatory field'),
		totalBorrowingsPercentageOfAnnualTurnover: yup.mixed().required('This is a mandatory field'),
		previousRelationshipExistsWithFS: yup.mixed().required('This is a mandatory field'),
		bankDetails: yup.array().of(
			yup.object().shape({
				rate: yup.number()
					.transform((v, o) => (o === '' || o === null ? 0 : v))
					.typeError('Rate must be a number')
					.min(0, 'Rate must be 0 or greater')
					.max(100, 'Rate must be 100 or less'),
				outstandingOrCleanExposure: yup.number()
					.transform((v, o) => (o === '' || o === null ? 0 : v))
					.typeError('O/S Amount must be a number')
					.min(0, 'O/S Amount must be 0 or greater'),
			})
		),
	}),
	vatComparison: yup.object().shape({
		vatReportXBankStatementTurnoverVariance: yup.mixed().required('This is a mandatory field'),
	})
});

export const CRFinancialsSchema = yup.object().shape({
	financialDetails: yup.object().shape({
		totalAnnualTurnover: yup.mixed().required('This is a mandatory field'),
		netOperatingProfit: yup.mixed().required('This is a mandatory field'),
		accountsReceivableConcentration: yup.mixed().required('This is a mandatory field'),
	}),

});

export const PromoCodeSchema = yup.object({
	code: yup.string().required('This is a mandatory field').max(10, 'Promo code should be less than 10 characters').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	type: yup.number().required('This is a mandatory field').nullable(),
	promoCodeLoans: yup.array().when('loanApplicable', {
		is: 2, // Condition to check
		then: yup
			.array()
			.min(1, 'This is a mandatory field'), // Validation rule
		otherwise: yup.array(), // No validation needed when loanApplicable !== 1
	}),
	startDate: yup.string()
		.nullable()
		.test(
			'is-before-expiry',
			'Start date must be earlier than expiry date.',
			function (value) {
				const { expiryDate } = this.parent; // Access sibling field
				if (!value || !expiryDate) return true; // Valid if either is null
				return new Date(value) < new Date(expiryDate); // Compare dates
			}
		),
	expiryDate: yup.string()
		.nullable()
		.test(
			'is-after-start',
			'Expiry date must be later than start date.',
			function (value) {
				const { startDate } = this.parent; // Access sibling field
				if (!value || !startDate) return true; // Valid if either is null
				return new Date(value) > new Date(startDate); // Compare dates
			}
		),
	promoCodeRanges: yup.array().of(
		yup.object({
			value: yup.number().typeError('This is a mandatory field')
				.required('This is a mandatory field')
				.min(0, 'Value must be 0 or greater')
		})
	),
});

export const AutoInvestmentSchema = yup.object().shape({
	preFillCampaignPercent: yup
		.number()
		.required('This is a mandatory field').typeError('This is a mandatory field')
		.nullable(),
	autoInvestmentConfigurationTypes: yup.array().of(
		yup.object({
			maxExposure: yup.number().typeError('This is a mandatory field')
				.required('This is a mandatory field')
				.nullable()
		})
	),
});

export const SMSTemplateSchema = yup.object({
	name: yup.string().required('This is a mandatory field').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const InvestorIntegrationInfoSchema = yup.object({
	enabled: yup
		.bool()
		.required('This is a mandatory field')
		.nullable()
		.transform((v, o) => (o === '' ? false : v)),
	webhook: yup
		.string()
		.nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
	arrangementFee: yup
		.number()
		.required('This is a mandatory field')
		.nullable()
		.transform((v, o) => (o === '' ? null : v)),
});


export const EmailChangeForm = yup.object({
	email: yup.string().email().required('Please enter your email').nullable()
		.trim()
		.transform((v, o) => (o === '' ? null : v)),
});

export const CRReferenceSchema = yup.object().shape({
	ecpvDetails: yup.object().shape({
		homeAddressVerificationProvided: yup
			.mixed()
			.required('This is a mandatory field')
			.nullable(),
		homeCountryContactNo: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		homeCountryAlternateContactNo: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		friendOrRelativeName: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		friendOrRelativeTelephone: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		friendOrRelativeAddress: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
		anySpecificNotes: yup
			.string()
			.required('This is a mandatory field')
			.nullable()
			.trim()
			.transform((v, o) => (o === '' ? null : v)),
	}),
});

export const MarketingSchema = yup.object().shape({
  fromDate: yup.date().nullable(),
  toDate: yup.date()
    .nullable()
    .min(
      yup.ref("fromDate"),
      "To Date cannot be earlier than From Date"
    ),
});
